export enum EUserGroup {
  HR = 'hr',
  ECDD = 'ecdd',
  DCDD = 'dcdd',
  CONFIGURATION = 'configuration',
  TRANSACTION = 'transaction',
  FINANCE = 'finance',
  PROJECT = 'project',
  SETTINGS = 'settings',
}
